<template>
  <SACModal
    modalClass="partner-agreement-action-modal"
    :cardClass="`paam-${actionModalView}`"
    :show="showActionModal"
    :close="() => toggleActionModal(false)"
  >
    <template
      v-if="actionModalView === 'new-payment-method'"
      #content
    >
      <NewPaymentMethod
        :corpId="selectedCorpId"
        :firstName="currentAdmin.firstName"
        :lastName="currentAdmin.lastName"
        :toEmail="currentAdmin.email"
        :changes="changePartnerAgreementValues"
        :toggleActionModal="toggleActionModal"
        :onSubmit="handleNewPaymentMethod"
        :showCreditCard="partnerSettings?.INVOICE_CREDIT_CARD_ENABLED"
      />
    </template>
    <template
      v-else-if="actionModalView === 'confirm-mandate'"
      #content
    >
      <ConfirmMandate
        :billingAddress="billingAddress"
        :setupIntent="setupIntent"
        :changes="changePartnerAgreementValues"
        :toggleActionModal="toggleActionModal"
        :onSubmit="handleNewPaymentMethod"
      />
    </template>
    <template
      v-else-if="actionModalView === 'upload-tax-doc'"
      #content
    >
      <UploadTaxDocument
        :toggleActionModal="toggleActionModal"
      />
    </template>
    <template
      v-else-if="actionModalView === 'new-agreement-order'"
      #content
    >
      <NewAgreementOrder
        :toggleActionModal="toggleActionModal"
      />
    </template>
    <template
      v-else-if="actionModalView === 'credit-card'"
      #content
    >
      <CreditCard
        :close="() => toggleActionModal(true, 'new-payment-method')"
        :onSubmit="handleCreditCard"
      />
    </template>
  </SACModal>
</template>

<script>
import { mapState } from 'vuex';

import SACModal from '@shared/components/sac/SACModal.vue';
import NewPaymentMethod from '../shared/billingModal/NewPaymentMethod.vue';
import CreditCard from '../shared/billingModal/CreditCard.vue';
import ConfirmMandate from '../shared/billingModal/ConfirmMandate.vue';
import UploadTaxDocument from './UploadTaxDocument.vue';
import NewAgreementOrder from './NewAgreementOrder.vue';

export default {
  name: 'ActionModal',
  components: {
    SACModal,
    NewPaymentMethod,
    CreditCard,
    ConfirmMandate,
    UploadTaxDocument,
    NewAgreementOrder,
  },
  computed: {
    ...mapState({
      currentAdmin: (state) => state.admin.current,
      selectedCorpId: (state) => state.partnerAgreement.selectedCorpId,
      showActionModal: (state) => state.partnerAgreement.showActionModal,
      actionModalView: (state) => state.partnerAgreement.actionModalView,
      setupIntent: (state) => state.partnerAgreement.setupIntent,
      allBranchInfo: (state) => state.partnerAgreement.allBranchInfo,
      partnerSettings: (state) => state.partnerAgreement.partnerSettings,
    }),
    billingAddress() {
      if (this.allBranchInfo[this.selectedCorpId]) {
        const {
          billingAddress,
        } = this.allBranchInfo[this.selectedCorpId];
        return billingAddress[0];
      }
      return {};
    },
  },
  methods: {
    changePartnerAgreementValues(changes) {
      this.$store.dispatch('changePartnerAgreementValues', changes);
    },
    toggleActionModal(show, view) {
      if (show) {
        this.$store.dispatch('changePartnerAgreementValues', [{
          field: 'showActionModal',
          value: show,
        }, {
          field: 'actionModalView',
          value: view,
        }]);
      } else {
        this.$store.dispatch('changePartnerAgreementValues', [{
          field: 'showActionModal',
          value: show,
        }]);
      }
    },
    async handleNewPaymentMethod() {
      await this.$store.dispatch('newAgreementPaymentMethod');
      this.toggleActionModal(false);
    },
    async handleCreditCard(tokenId) {
      this.$store.dispatch('changePartnerAgreementValues', [{
        field: 'cardToken',
        value: tokenId,
      }, {
        field: 'paymentMethod',
        value: 'Credit Card',
      }]);
      await this.$store.dispatch('newAgreementPaymentMethod');
      this.toggleActionModal(false);
    },
  },
};
</script>

<style lang="scss">
.partner-agreement-action-modal {
  .paam-new-payment-method {
    width: 400px;
    height: 500px;
  }
  .paam-confirm-mandate {
    width: 600px;
    height: 480px;
  }
  .paam-upload-tax-doc {
    width: 600px;
    height: 500px;
  }
  .paam-new-agreement-order {
    width: 1100px;
    max-height: 850px;
  }
  .paam-credit-card {
    width: 400px;
    height: 280px;
  }
  .ac-header-container {
    padding: 29px 24px 19px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between !important;
    border-bottom: 1px solid $NBLUE10;
    .ac-header {
      font-size: 1.25rem;
      font-weight: 500;
    }
    .ac-close-button {
      width: 32px;
      height: 32px;
      border-radius: 6px;
      background-color: $NBLUE10;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        background-color: $NBLUE20;
      }
      .ac-close {
        width: 10px;
        height: 10px;
      }
    }
  }
  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    .ac-body-container {
      flex: 1;
      padding: 24px;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      .ac-body-header {
        font-size: 1.125rem;
        font-weight: 500;
        text-align: center;
      }
      .ac-body-terms {
          flex: 1;
          font-size: 1.125rem;
          color: $N100;
          text-align: justify;
      }
      .ac-info-container {
        &:not(:last-child) {
          margin-bottom: 8px;
        }
        .ac-header {
          width: 40%;
          font-size: 1.125rem;
          font-weight: 500;
          color: $N100;
        }
        .ac-body {
          flex: 1;
          font-size: 1.125rem;
          color: $N100;
          text-align: right;
        }
      }
      .ac-input-container {
        &:not(:last-child) {
          margin-bottom: 12px;
        }
        .ac-input-header {
          font-size: 1.125rem;
          font-weight: 500;
          margin-bottom: 4px;
          .ac-input-sub {
            font-size: 0.75rem;
            color: $N50;
          }
        }
        input {
          height: 48px;
          width: 100%;
          background-color: $NBLUE5;
          border: none;
          border-radius: 2px;
          padding: 0 10px;
        }
      }
    }
  }
  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid $NBLUE10;
    .ac-form-button {
      width: 120px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE10;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE20;
      }
      &:not(:first-child) {
        margin-left: 11px;
        background-color: $NBLUE100;
        color: $WHITE;
        &:hover {
          background-color: $NBLUE90;
        }
      }
    }
    .ac-form-cancel-button {
      width: 120px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE10;
      font-weight: 600;
      &:hover {
        background-color: $NBLUE20;
      }
    }
  }
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
